import { render } from "./MaandumisLeht.vue?vue&type=template&id=79142c2e&scoped=true&ts=true"
import script from "./MaandumisLeht.vue?vue&type=script&lang=ts"
export * from "./MaandumisLeht.vue?vue&type=script&lang=ts"

import "./MaandumisLeht.vue?vue&type=style&index=0&id=79142c2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79142c2e"]])

export default __exports__